import firebase from '@firebase/app'
import '@firebase/firestore'
import '@firebase/analytics'

const config = {
  apiKey: 'AIzaSyCH8_v28U3FLKGf29y3sGnFLa6fI1iMNt8',
  authDomain: 'xerpa-40c1c.firebaseapp.com',
  databaseURL: 'https://xerpa-40c1c.firebaseio.com',
  projectId: 'xerpa-40c1c',
  storageBucket: 'gs://xerpa-40c1c.appspot.com/',
  messagingSenderId: '905931821355',
  appId: '1:905931821355:web:52ecd93e4f9c584663b56e',
  measurementId: 'G-CR3LTH2XJ3'
}
firebase.initializeApp(config)
firebase.firestore().settings({
  ignoreUndefinedProperties: true
})

export default firebase.firestore()
export { firebase }
